<template name="LandingPage">
  <div></div>
</template>

<script>


export default {
  name: "LandingPage",
//   components: {
   
// //   },

  mounted() {
    // console.log(this.$vuetify.theme);
  },
  methods: {
   
  }
};
</script>
